import { render, staticRenderFns } from "./VendorSelect.vue?vue&type=template&id=95250fb2&scoped=true"
import script from "./VendorSelect.vue?vue&type=script&lang=js"
export * from "./VendorSelect.vue?vue&type=script&lang=js"
import style0 from "./VendorSelect.vue?vue&type=style&index=0&id=95250fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95250fb2",
  null
  
)

export default component.exports